import React from 'react';
import TextField from '@material-ui/core/TextField';

export default function InputField(props) {
  const size = props.size ? props.size : 'small';
  const fieldError = props.error ? true : false;
  const fieldId = props.id ? props.id : 'outlined-basic';
  const fieldValue = props.value == null ? '' : props.value;
  const fieldVariant = props.variant ? props.variant : 'outlined';
  const divMarginStyle = props.marginStyle ? props.marginStyle : 'mt-3';

  return (
    <div className={divMarginStyle} noValidate autoComplete="off">
      <TextField
        type={props.type}
        id={fieldId}
        label={props.placeholder}
        variant={fieldVariant}
        fullWidth
        name={props.name}
        onChange={props.onChange}
        onBlur={props.onBlur}
        disabled={props.disabled}
        value={fieldValue}
        error={fieldError}
        required={props.required}
        autoComplete={props.autoComplete}
        multiline={props.multiline}
        rows={props.rows}
        autoFocus={props.autoFocus}
        size={size}
        InputLabelProps={{
          style: {
            color: 'rgb(94, 94, 94)',
          },
          shrink: true,
        }}
        InputProps={{
          inputProps: {
            min: props.onlyPositive && 0,
            style: {
              color: props.boldText && 'black',
              fontWeight: props.boldText && 500,
            },
          },
        }}
      />
      {props.error && (
        <b>
          <div style={{ color: 'red' }}>{props.error}</div>
        </b>
      )}
    </div>
  );
}
